/* TFP — sugerencias en vivo bajo la barra de búsqueda (endpoint nativo predictive_search_url).
   v6.1 2026-10-12 (post review PRE Codex): SIN analítica propia (decisión Herman: cero
   instrumentación de Google; Shopify Analytics nativa vía /search se mantiene). invalidate()
   único para Escape/Tab/clic fuera/focusout y limpia el anuncio de carga; caché {query,kind}
   incl. vacío (reabrir restaura mensaje); listbox con id propio + aria-controls; CTA fuera del
   listbox pero alcanzable por Tab; panel flex; composición; validación estricta del payload;
   "Buscando…" ligado al request vigente; modo compacto; prefijo "Colección ·" accesible.
   LIVE-1 (2026-10-12): html.tfp-search-open mientras hay un panel abierto → CSS oculta widgets flotantes. */
(function () {
  var MIN_CHARS = 2, DEBOUNCE = 220, LOADING_DELAY = 300, PRODUCT_LIMIT = 6, COLLECTION_LIMIT = 3, COMPACT_BELOW = 360;
  var hasFetch = typeof window.fetch === 'function';
  var hasAbort = typeof window.AbortController === 'function';

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function money(v) {
    var n = Math.round(parseFloat(v));
    return isNaN(n) ? '' : '$' + n.toLocaleString('es-CL');
  }
  function priceLabel(p) {
    if (p.available === false) return 'Agotado';
    var min = parseFloat(p.price_min), max = parseFloat(p.price_max);
    if (!isNaN(min) && !isNaN(max) && max > min) return 'Desde ' + money(min);
    return money(p.price != null ? p.price : min);
  }
  function thumb(p) {
    var u = p.featured_image && p.featured_image.url;
    return u ? u.replace(/(\.[a-zA-Z]+)(\?|$)/, '_120x120$1$2') : '';
  }
  function sameOriginHref(u) {
    try {
      var url = new URL(String(u || ''), window.location.origin);
      if (url.origin !== window.location.origin || !/^https?:$/.test(url.protocol)) return null;
      return url.pathname + url.search + url.hash;
    } catch (e) { return null; }
  }
  function isObjArray(a) {
    return Array.isArray(a) && a.every(function (x) { return x && typeof x === 'object'; });
  }
  function init(root) {
    if (!root || root.__tfpSearch || !hasFetch) return;
    var form = root.querySelector('.tfp-search__form');
    var input = root.querySelector('input[type=search]');
    var clearBtn = root.querySelector('.tfp-search__clear');
    var panel = root.querySelector('.tfp-search__results');
    var msg = root.querySelector('.tfp-search__msg');
    var list = root.querySelector('.tfp-search__list');
    var cta = root.querySelector('.tfp-search__all');
    var status = root.querySelector('.tfp-search__status');
    if (!form || !input || !panel || !msg || !list || !cta) return;

    var uid = root.getAttribute('data-uid') || 'main';
    if (!list.id) list.id = 'tfp-search-' + uid + '-listbox';
    list.setAttribute('tabindex', '-1'); // scroller fuera del orden de Tab (Chrome keyboard-focusable scrollers)
    var suggestUrl = root.getAttribute('data-suggest-url') || '/search/suggest';
    if (!/\.json($|\?)/.test(suggestUrl)) suggestUrl = suggestUrl.replace(/\/?(\?.*)?$/, function (m, qs) { return '.json' + (qs || ''); });
    var searchUrl = form.getAttribute('action') || root.getAttribute('data-search-url') || '/search';

    // Mejora progresiva: roles solo cuando el JS está activo
    input.setAttribute('role', 'combobox');
    input.setAttribute('aria-autocomplete', 'list');
    input.setAttribute('aria-haspopup', 'listbox');
    input.setAttribute('aria-controls', list.id);
    input.setAttribute('aria-expanded', 'false');

    var listeners = [];
    var state = { timer: null, loadTimer: null, ctrl: null, reqId: 0, cache: null, options: [], active: -1, composing: false, raf: null };
    function on(el, ev, fn, opts) { el.addEventListener(ev, fn, opts); listeners.push([el, ev, fn, opts]); }

    function fullSearchHref(q) {
      return searchUrl + (searchUrl.indexOf('?') > -1 ? '&' : '?') + 'type=product&q=' + encodeURIComponent(q);
    }
    function announce(t) { if (status) status.textContent = t || ''; }
    function syncClear() { if (clearBtn) clearBtn.hidden = !input.value.length; }

    function setActive(i) {
      if (state.active > -1 && state.options[state.active]) {
        state.options[state.active].classList.remove('is-active');
        state.options[state.active].setAttribute('aria-selected', 'false');
      }
      state.active = i;
      if (i > -1 && state.options[i]) {
        var el = state.options[i];
        el.classList.add('is-active'); el.setAttribute('aria-selected', 'true');
        input.setAttribute('aria-activedescendant', el.id);
        scrollOptionIntoView(el);
      } else {
        input.removeAttribute('aria-activedescendant');
      }
    }
    function scrollOptionIntoView(el) {
      var top = el.offsetTop, bottom = top + el.offsetHeight;
      if (top < list.scrollTop) list.scrollTop = top;
      else if (bottom > list.scrollTop + list.clientHeight) list.scrollTop = bottom - list.clientHeight;
    }
    function fitHeight() {
      var vv = window.visualViewport;
      var bottom = vv ? (vv.offsetTop + vv.height) : window.innerHeight;
      var top = panel.getBoundingClientRect().top;
      var avail = Math.max(0, Math.floor(bottom - top - 12));
      panel.style.maxHeight = avail + 'px';
      panel.classList.toggle('is-compact', avail < COMPACT_BELOW);
    }
    function scheduleFit() {
      if (panel.hidden) return;
      if (state.raf) cancelAnimationFrame(state.raf);
      state.raf = requestAnimationFrame(function () { state.raf = null; fitHeight(); });
    }

    // LIVE-1: mientras ALGÚN panel de buscador esté abierto, <html class="tfp-search-open"> oculta los widgets
    // flotantes (Fuel Planner, WhatsApp) para que no tapen el CTA. Estado derivado del DOM, no de esta instancia (PRE-L1-1).
    function syncWidgetClass() {
      var anyOpen = !!document.querySelector('[data-tfp-search] .tfp-search__results:not([hidden])');
      document.documentElement.classList.toggle('tfp-search-open', anyOpen);
    }
    function closePanel() {
      panel.hidden = true; list.hidden = true; msg.hidden = true; cta.hidden = true;
      input.setAttribute('aria-expanded', 'false');
      setActive(-1);
      syncWidgetClass();
    }
    function invalidate() {
      clearTimeout(state.timer); state.timer = null;
      clearTimeout(state.loadTimer); state.loadTimer = null;
      state.reqId += 1;
      if (state.ctrl) { try { state.ctrl.abort(); } catch (e) {} state.ctrl = null; }
      input.removeAttribute('aria-busy');
      if (status && status.textContent === 'Buscando…') announce(''); // PRE61-1: no dejar "Buscando…" pegado al cancelar
      closePanel();
    }
    function openPanel(withList) {
      panel.hidden = false;
      list.hidden = !withList;
      input.setAttribute('aria-expanded', withList ? 'true' : 'false');
      syncWidgetClass();
      fitHeight();
    }
    function showCta(q) { cta.href = fullSearchHref(q); cta.textContent = 'Ver resultados de “' + q + '” →'; cta.hidden = false; }

    function renderMessage(kind, text, q) {
      list.innerHTML = ''; state.options = []; state.active = -1; input.removeAttribute('aria-activedescendant');
      msg.className = 'tfp-search__msg ' + (kind === 'error' ? 'tfp-search__error' : 'tfp-search__empty');
      msg.textContent = text; msg.hidden = false;
      showCta(q);
      state.cache = kind === 'empty' ? { query: q, kind: 'empty' } : null;
      openPanel(false);
    }
    function renderResults(q, prods, cols) {
      var h = '';
      if (cols.length) {
        h += '<div class="tfp-search__group" role="presentation">Colecciones</div><div class="tfp-search__cols" role="presentation">';
        cols.forEach(function (c) {
          var href = sameOriginHref(c.url); if (!href) return;
          h += '<a class="tfp-search__col" role="option" tabindex="-1" data-type="collection" href="' + esc(href) + '"><span class="tfp-search__prefix">Colección · </span>' + esc(c.title) + '</a>';
        });
        h += '</div>';
      }
      if (prods.length) {
        h += '<div class="tfp-search__group" role="presentation">Productos</div>';
        prods.forEach(function (p) {
          var href = sameOriginHref(p.url); if (!href) return;
          var img = thumb(p), sold = p.available === false;
          h += '<a class="tfp-search__item' + (sold ? ' is-soldout' : '') + '" role="option" tabindex="-1" data-type="product" href="' + esc(href) + '">'
            + (img ? '<img src="' + esc(img) + '" alt="" width="48" height="48" loading="lazy">' : '<span class="tfp-search__noimg"></span>')
            + '<span class="tfp-search__title">' + esc(p.title) + '</span>'
            + '<span class="tfp-search__price">' + esc(priceLabel(p)) + '</span></a>';
        });
      }
      list.innerHTML = h;
      state.options = Array.prototype.slice.call(list.querySelectorAll('[role=option]'));
      state.options.forEach(function (el, i) { el.id = list.id + '-opt-' + i; el.setAttribute('aria-selected', 'false'); });
      state.active = -1; input.removeAttribute('aria-activedescendant');
      msg.hidden = true; showCta(q);
      state.cache = { query: q, kind: 'results' };
      openPanel(true);
      announce(prods.length + ' producto' + (prods.length === 1 ? '' : 's') + (cols.length ? ' y ' + cols.length + ' colecci' + (cols.length === 1 ? 'ón' : 'ones') : '') + ' para ' + q + '. Usa las flechas para navegar.');
    }
    function render(q, data) {
      var r = data && data.resources && data.resources.results;
      if (!r || typeof r !== 'object') return renderError(q);
      var P = r.products == null ? [] : r.products, C = r.collections == null ? [] : r.collections;
      if (!isObjArray(P) || !isObjArray(C)) return renderError(q);
      var prods = P.slice(0, PRODUCT_LIMIT), cols = C.slice(0, COLLECTION_LIMIT);
      if (!prods.length && !cols.length) {
        renderMessage('empty', 'No encontramos sugerencias para “' + q + '”. Prueba con una marca o categoría.', q);
        announce('Sin sugerencias para ' + q);
        return;
      }
      renderResults(q, prods, cols);
    }
    function renderError(q) {
      renderMessage('error', 'No pudimos cargar las sugerencias. Prueba la búsqueda completa.', q);
      announce('No pudimos cargar las sugerencias');
    }
    function canRender(id, q) {
      return id === state.reqId && root.isConnected && !state.composing
        && input.value.trim() === q && (document.activeElement === input || panel.contains(document.activeElement));
    }
    function search(q) {
      var id = ++state.reqId;
      state.ctrl = hasAbort ? new AbortController() : null;
      var url = suggestUrl + (suggestUrl.indexOf('?') > -1 ? '&' : '?') + 'q=' + encodeURIComponent(q)
        + '&resources[type]=product,collection&resources[limit]=' + PRODUCT_LIMIT
        + '&resources[limit_scope]=each&resources[options][unavailable_products]=last';
      input.setAttribute('aria-busy', 'true');
      state.loadTimer = setTimeout(function () { state.loadTimer = null; if (id === state.reqId) announce('Buscando…'); }, LOADING_DELAY);
      // Orden fijo (PRE-5 / PRE61-1): 1) vigencia, 2) limpiar carga del request vigente, 3) permiso de pintar.
      // Una respuesta obsoleta sale en (1) sin tocar el timer/estado del request nuevo.
      function settle() {
        clearTimeout(state.loadTimer); state.loadTimer = null;
        input.removeAttribute('aria-busy');
        if (status && status.textContent === 'Buscando…') announce('');
      }
      fetch(url, state.ctrl ? { signal: state.ctrl.signal } : {})
        .then(function (res) { if (!res.ok) throw new Error('HTTP ' + res.status); return res.json(); })
        .then(function (d) {
          if (id !== state.reqId) return;
          settle();
          if (!canRender(id, q)) return;
          render(q, d);
        })
        .catch(function (err) {
          if (err && err.name === 'AbortError') return;
          if (id !== state.reqId) return;
          settle();
          if (!canRender(id, q)) return;
          renderError(q);
        });
    }
    function schedule() {
      var q = input.value.trim();
      invalidate(); syncClear();
      if (q.length < MIN_CHARS) return;
      state.timer = setTimeout(function () { state.timer = null; search(q); }, DEBOUNCE);
    }
    function reopenFromCache(q) {
      if (!state.cache || state.cache.query !== q) return false;
      if (state.cache.kind === 'results') { msg.hidden = true; showCta(q); openPanel(true); }
      else { msg.hidden = false; showCta(q); openPanel(false); announce('Sin sugerencias para ' + q); }
      return true;
    }
    function selectOption(el) { window.location.href = el.href; } // Enter sobre opción activa; el clic lo resuelve el <a> nativo

    on(input, 'compositionstart', function () { state.composing = true; invalidate(); });
    on(input, 'compositionend', function () { state.composing = false; schedule(); });
    on(input, 'input', function () { if (!state.composing) schedule(); else syncClear(); });
    on(input, 'focus', function () {
      var q = input.value.trim();
      if (q.length < MIN_CHARS) return;
      if (!reopenFromCache(q)) schedule();
    });
    on(input, 'keydown', function (e) {
      if (state.composing || e.isComposing || e.keyCode === 229) return;
      if (e.key === 'Escape') { e.preventDefault(); invalidate(); return; }
      if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
        if (list.hidden && !reopenFromCache(input.value.trim())) return;
        if (list.hidden || !state.options.length) return;
        e.preventDefault();
        var n = state.options.length, i = state.active;
        setActive(e.key === 'ArrowDown' ? (i + 1) % n : (i <= 0 ? n - 1 : i - 1));
        return;
      }
      if (e.key === 'Enter' && !list.hidden && state.active > -1 && state.options[state.active]) {
        e.preventDefault(); selectOption(state.options[state.active]); return;
      }
    });
    on(list, 'mousedown', function (e) { if (e.button === 0 && e.target.closest && e.target.closest('[role=option]')) e.preventDefault(); });
    if (clearBtn) {
      on(clearBtn, 'mousedown', function (e) { e.preventDefault(); });
      on(clearBtn, 'click', function () { input.value = ''; state.cache = null; invalidate(); syncClear(); input.focus(); announce('Búsqueda borrada'); });
    }
    on(root, 'focusout', function (e) { if (!e.relatedTarget || !root.contains(e.relatedTarget)) invalidate(); });
    on(document, 'pointerdown', function (e) { if (!root.contains(e.target)) invalidate(); });
    on(window, 'resize', scheduleFit);
    if (window.visualViewport) { on(window.visualViewport, 'resize', scheduleFit); on(window.visualViewport, 'scroll', scheduleFit); }
    syncClear();

    root.__tfpSearch = {
      dispose: function () {
        invalidate();
        if (state.raf) cancelAnimationFrame(state.raf);
        listeners.forEach(function (l) { l[0].removeEventListener(l[1], l[2], l[3]); });
        listeners = [];
        delete root.__tfpSearch;
      }
    };
  }

  function initAll(scope) { Array.prototype.forEach.call((scope || document).querySelectorAll('[data-tfp-search]'), init); }
  function disposeIn(scope) {
    Array.prototype.forEach.call((scope || document).querySelectorAll('[data-tfp-search]'), function (r) { if (r.__tfpSearch) r.__tfpSearch.dispose(); });
  }
  if (!window.__tfpSearchBound) {
    window.__tfpSearchBound = true;
    document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
    document.addEventListener('shopify:section:unload', function (e) { disposeIn(e.target); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(); });
  else initAll();
  window.tfpSearchInit = initAll;
})();
